import { render, staticRenderFns } from "./App.vue?vue&type=template&id=0884c45c&scoped=true&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=0884c45c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0884c45c",
  null
  
)

export default component.exports